<template>
  <div class="home-description" ref="el">
    <p class="home__description__text sp-20" data-split>
      {{ globals.description }}
    </p>
    <div class="fs-16" data-split>
      <PrismicRichText
        :field="globals?.jury_awwwards"
        :components="components"
      />
    </div>
  </div>
</template>

<script setup>
const globals = useGlobal();
const props = defineProps({});
const el = ref(null);
const { $gsap: gsap, $SplitText: SplitText } = useNuxtApp();
import PrismicLink from '@/components/PrismicLink.vue';

const components = {
  hyperlink: PrismicLink,
};

onMounted(() => {
  gsap.context(() => {
    SplitText.create(qsa('[data-split]', el.value), {
      type: 'lines',
      mask: 'lines',
      // autoSplit: true,
      linesClass: 'line',
      wordsClass: 'word',
      smartWrap: true,
      onSplit: self => {
        self?.lines?.forEach((myLine, i) => {
          gsap.set(myLine, { '--index': i });
        });
      },
    });
  }, el.value);
});
</script>

<style lang="scss" scoped>
.home-description {
  @include mqDown(desktop) {
    top: calc(var(--offset-double) + 1em);
    width: var(--col-4);
    padding: var(--offset);
  }

  @include mq(desktop) {
    top: var(--offset);
    width: var(--col-1);
    left: calc(var(--offset) + col(5));
  }

  z-index: layer(overlay);
  position: absolute;
  color: var(--c-text);

  &:deep(.line) {
    transition: transform 1s ease(outExpo) calc(var(--index) * 0.1s);
    transform: translateY(120%);
  }

  &.is-animated {
    &:deep(.line) {
      transform: translateY(0%);
    }
  }
}

.home__description__text {
  @include fs(48);

  @include mq(desktop) {
    @include fs(16);
  }
}
</style>
